import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a11c979&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a11c979')) {
      api.createRecord('0a11c979', component.options)
    } else {
      api.reload('0a11c979', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a11c979&", function () {
      api.rerender('0a11c979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vrach/index.vue"
export default component.exports